import React, { useState, useEffect, useCallback } from 'react';
import { getSuggestions } from '../../services/getSuggestions';
import { postToken } from '../../services/postToken';
import { MAX_RETRIES } from '../../constantes/constantes';

export default function Sugerencias({ palabra, setText, setTextNew, setShowSugerencias, inputRef, token, hasFocus, setQuery,
    setToken,
    setErrorService,
    setRetrySearch,
    sessionId,
    errorService,
    category,
    isMobile,
    onQueryChange,
    listaSugerencias,
    setListaSugerencias,
    setSelectedIndex,
    selectedIndex
}) {
    
    const [initialText, setInitialText] = useState(palabra);
    const [retryCount, setRetryCount] = useState(0);
    const regexAlphaNumerico = /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/;

    // Función para hacer la petición de sugerencias
    const fetchSuggestions = useCallback(() => {
        // console.log(" retry count: ", retryCount, " max: ",MAX_RETRIES, " tokeN : ", token)
        if (palabra && palabra.length >= 3 && hasFocus && retryCount < 1) {
            getSuggestions(palabra, token, category)
                .then((sugerencia) => {
                    if (sugerencia) {
                        if (sugerencia.statusCode !== 401) {
                            setListaSugerencias(sugerencia.data);
                        } else {
                            handleUnauthorizedError();
                        }
                    } else {
                        setListaSugerencias([]);
                    }
                })
                .catch((error) => {
                    setListaSugerencias([]);
                });
        } else {
            setListaSugerencias([]);
        }
    }, [palabra, hasFocus, token]);

    // Efecto para hacer la petición de sugerencias
    useEffect(() => {
        fetchSuggestions();
    }, [palabra, hasFocus, token, fetchSuggestions]);

    // Función para manejar el error 401
    const handleUnauthorizedError = useCallback(() => {
        if (retryCount < MAX_RETRIES) {
            setRetryCount(retryCount + 1);
            setErrorService(true);
            // callPostToken();
        } else {
            console.error(`Se alcanzó el máximo de reintentos: ${MAX_RETRIES}`);
        }
    }, [retryCount]);

    // desplazamiento por el listado de sugerencias
    const handleKeyDown = useCallback((e) => {
        let key = e.key || e.which || e.keyCode;
        if (e.key === 'ArrowDown') {
            setSelectedIndex((prevIndex) =>
                Math.min(prevIndex + 1, listaSugerencias.length - 1)
            );
        } else if (e.key === 'ArrowUp') {
            setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
        }
        else if (e.key === 'Enter' || key === 'Go' || key === 13) {
            if (listaSugerencias && listaSugerencias[selectedIndex] && listaSugerencias[selectedIndex].sugerencia) {
                // Dividir el string en palabras
                let palabras = listaSugerencias[selectedIndex].sugerencia.split(' ');
                // Eliminar la última palabra
                if (palabras.length > 1) {
                    palabras = palabras.slice(0, -1);
                }
                // Unir las palabras de nuevo en un string
                let nuevoValor = String(palabras.join(' ')).trim();
                nuevoValor = nuevoValor.replace(/^[^a-zA-Z0-9]+/, '');

                if (inputRef.current) {
                    inputRef.current.value = nuevoValor;
                    setSelectedIndex(-1);
                  }
            
                // setText(nuevoValor);
                setTextNew(nuevoValor)

                // setQuery(nuevoValor);
                // onQueryChange(nuevoValor);
            }
            setTimeout(() => {
                setShowSugerencias(false);
            }, 100);
        }
    }, [selectedIndex, listaSugerencias, initialText]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    //
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    //
    useEffect(() => {
        if (selectedIndex >= 0 && selectedIndex < listaSugerencias.length) {
            setCaretPositionToEnd(inputRef.current);
            // const selectedText = listaSugerencias[selectedIndex].sugerencia;
            // setTextNew(selectedText); // Actualiza el valor del input en tiempo real
        }
    }, [selectedIndex, listaSugerencias, inputRef]);

    // selecciona la opcion del listado de sugerencias
    const selectSuggestion = (valor) => {

        // Dividir el string en palabras
        let palabras = valor.split(' ');
        // Eliminar la última palabra
        if (palabras.length > 1) {
            palabras = palabras.slice(0, -1);
        }
        // Unir las palabras de nuevo en un string
        let nuevoValor = String(palabras.join(' ')).trim();
        nuevoValor = nuevoValor.replace(/^[^a-zA-Z0-9]+/, '');
        
        setText(nuevoValor);
        setTextNew(nuevoValor)
        setQuery(nuevoValor);
        setTextNew(nuevoValor);
        onQueryChange(nuevoValor);
        setTimeout(() => {
            setShowSugerencias(false);
        }, 100);
    }

    // posicionar el focus al final del value en el input al desplazar por el listado de sugerencias
    const setCaretPositionToEnd = (input) => {
        let length = palabra.length;
        input.focus();
        input.setSelectionRange(length, length);
    };


    return (
        <>
            {hasFocus && listaSugerencias && <div className='lista-sugerencias'>
                <ul>
                    {listaSugerencias && listaSugerencias.filter((_, i) => !isMobile || i < 3).map((ele, i) => (
                        <li key={i}
                            // onClick={() => selectSuggestion(ele.sugerencia)}
                            className={i === selectedIndex ? 'selected' : ''}
                            // onMouseDown={() => handleSuggestionClick(ele.sugerencia.replace(/^[^a-zA-Z0-9]+/, ''))}
                            onTouchEnd={() => selectSuggestion(ele.sugerencia)}

                            onMouseDown={() => selectSuggestion(ele.sugerencia)}
                        >
                            <span className='icon-search'></span> {ele.sugerencia.replace(/^[^a-zA-Z0-9]+/, '')}
                        </li>
                    ))}
                </ul>
            </div>
            }
        </>
    )
}